<template>
  <div class="scroll-wrapper">
    <div class="client-payments">
      <el-form :inline="true" class="toolbar" @submit.prevent>
      <el-form-item>
        <el-date-picker
          v-model="filters.dates"
          type="daterange"
          start-placeholder="Начало"
          end-placeholder="Конец"
          format="dd.MM.yyyy"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item>
        <el-select v-model="filters.method" placeholder="Метод" clearable>
          <el-option label="Наличные" value="cash" />
          <el-option label="Безнал" value="cashless" />
          <el-option label="Абонемент" value="abonement" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadPayments">Обновить</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="payments" style="width: 100%; margin-top: 20px;" :row-class-name="rowClassName">
      <el-table-column label="Дата" width="150">
        <template #default="{ row }">
          <span>{{ new Date(row.created_at * 1000).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="client_name" label="Клиент" />
      <el-table-column prop="method" label="Метод" width="150">
        <template #default="{ row }">
          <span v-if="row.method === 'cash'">Наличные</span>
          <span v-else-if="row.method === 'cashless'">Безналичный</span>
          <span v-else-if="row.method === 'abonement'">Абонемент</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="Сумма" width="120">
        <template #default="{ row }">
          <el-tooltip
            v-if="(row.is_canceled || row.type === 'refund') && row.cancel_reason"
            :content="row.cancel_reason"
            placement="top">
            <div>
              <span
                class="payment-amount"
                :class="{ 'is-canceled': row.is_canceled || row.type === 'refund' }"
                :style="{ color: row.direction === 'out' ? 'var(--ui-color-danger-el)' : 'var(--ui-color-success)' }"
              >
                {{ row.direction === 'out' ? '–' : '+' }}{{ row.amount }} ₽
              </span>
            </div>
          </el-tooltip>
          <span
            v-else
            class="payment-amount"
            :class="{ 'is-canceled': row.is_canceled || row.type === 'refund' }"
            :style="{ color: row.direction === 'out' ? 'var(--ui-color-danger-el)' : 'var(--ui-color-success)' }"
          >
            {{ row.direction === 'out' ? '–' : '+' }}{{ row.amount }} ₽
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="Комментарий" />
    </el-table>

      <el-pagination
      v-if="total > limit"
      style="margin-top: 20px; text-align: right"
      background
      layout="prev, pager, next, jumper"
      :page-size="limit"
      :current-page="page"
      :total="total"
      @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ClientPayments',
  data() {
    return {
      filters: {
        dates: [],
        method: null
      },
      limit: 50,
      page: 1,
    }
  },
  computed: {
    ...mapState('payments', ['payments', 'total'])
  },
  methods: {
    ...mapActions('payments', ['fetchPayments', 'refundPayment', 'cancelPayment']),
    changePage(page) {
      this.page = page
      this.loadPayments()
    },
    loadPayments() {
      const params = {
        page: this.page,
        limit: this.limit,
        filters: {
          method: this.filters.method,
          date_from: this.filters.dates?.[0] || null,
          date_to: this.filters.dates?.[1] || null
        }
      }
      this.fetchPayments(params);
    },
    rowClassName({ row }) {
      return row.is_canceled || row.type === 'refund' ? 'is-canceled' : '';
    }
  },
  watch: {
    'filters.method'() {
      this.page = 1
      this.loadPayments()
    },
    'filters.dates': {
      handler() {
        this.page = 1
        this.loadPayments()
      },
      deep: true
    }
  },
  mounted() {
    this.loadPayments()
  }
}
</script>

<style scoped>
.client-payments {
  padding: 20px;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.payment-amount {
  font-size: 16px;
  font-weight: 600;
}
.is-canceled {
  text-decoration: line-through;
  color: var(--ui-color-text-muted);
}
</style>
